// extracted by mini-css-extract-plugin
export default {"container":"jJLqALtJ_ZTgvgT3KcdA","filter":"c9DaD2WJugyOWK0E67WY","remove-button":"e17V9CVFHL9RjFwSEROp"};